import styled, { keyframes } from "styled-components";
import { MAIN_BLUE } from "../../styles/Colors";
import { below } from "../../utils/Breakpoints";

const fadeIn = keyframes`
    from {
        width: 0;
        height: 0;
        top: 50%;
      }
    
      to {
        width: 1;
        height: 1;
        left: 0;
        top: 0;
      }
`;
const textfadeIn = keyframes`
from {
    opacity: 0;
}
to{
    opacity: 1;
}
`;
export const BackgroundModal = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
`;

export const StyledModal = styled.div`
  overflow: hidden;
  display: ${(props) =>
    props.open ? "block" : "none"}; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 40%;
  height: 95%;
  animation: ${fadeIn} 0.3s;
  border-radius: 10px;
  ${below.small`
    width:80%;
  `}
`;
export const HeaderModal = styled.div`
  width: 100%;
  min-height: 10%;
  border-bottom: 1px solid ${MAIN_BLUE};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  animation: ${textfadeIn} 1s;
`;
export const TitleModal = styled.span`
  box-sizing: border-box;
  font-size: 1.5rem;
  flex-grow: 1;
  margin-bottom: 5px;
  ${below.small`
    font-size:1rem;
    text-align:center;
  `}
`;

export const CloseButton = styled.img`
  color: ${MAIN_BLUE};
  width: 20px;
  position: relative;
  font-weight: bold;
  &:hover,
  &:focus {
    filter: brightness(5);
    text-decoration: none;
    cursor: pointer;
  }
`;

export const BodyModal = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  animation: ${textfadeIn} 1s;
`;

export const ModalImage = styled.img`
  width: 100%;
  object-fit: contain;
  max-height: 150px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
`;
export const ModalAssets = styled.div`
  width: 100%;
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  margin: 10px 0;
`;
export const ModalDescription = styled.p`
  width: 100%;
  font-size: 0.9rem;
  word-break: break-all;
  text-overflow: ellipsis;
`;
export const ModalDetails = styled.span`
  width: 100%;
  word-break: break-all;
  text-overflow: ellipsis;
`;

export const ModalButton = styled.a`
  width: 100%;
  padding: 10px;
  background-color: ${MAIN_BLUE};
  border-radius: 20px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  ${below.large`
  `}
  &:hover {
    box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.2);
  }
`;
